<template>
  <transition name="fade" mode="out-in">
    <CustomerAlreadyLoggedInForm v-if="showLoggedInForm" />
    <FormViewBase
      v-else-if="isVerifyingEmail"
      title="Login to Verify your Email"
    >
      <template #default>
        <transition name="fade" mode="out-in">
          <LoginEmailPassForm />
        </transition>
      </template>
    </FormViewBase>
    <FormViewBase v-else title="Customer Login">
      <template #header>
        <CustomerFindAccountByPhoneNotice />
      </template>
      <template #default>
        <transition name="fade" mode="out-in">
          <LoginEmailPassForm />
        </transition>
      </template>
      <template #actions>
        <v-card-actions>
          <v-row class="text-center text-h6">
            <v-col class=""
              >Don't have an account yet?
              <router-link
                exact
                :to="{ name: CustomerSignupRoute, query: { ...$route.query } }"
                class="ml-1"
                >Signup Now</router-link
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </template>
    </FormViewBase>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import { CustomerRoutes } from '@/constants/RouteNames'
import FormViewBase from '@/views/FormViewBase'

import LoginEmailPassForm from '@/components/LoginEmailPassForm'
import CustomerFindAccountByPhoneNotice from '@/components/CustomerFindAccountByPhoneNotice'
import CustomerAlreadyLoggedInForm from '@/components/CustomerAlreadyLoggedInForm'
export default {
  name: 'CustomerLoginView',
  components: {
    LoginEmailPassForm,
    FormViewBase,
    CustomerFindAccountByPhoneNotice,
    CustomerAlreadyLoggedInForm,
  },
  data: () => {
    return {
      CustomerSignupRoute: CustomerRoutes.SIGNUP,
      showLoggedInForm: false,
    }
  },
  created() {
    this.showLoggedInForm = this.isCustomer
  },
  computed: {
    ...mapGetters('auth', ['isCustomer']),
    isVerifyingEmail() {
      return !!this.$route.query.verifyEmailPath
    }, // isVerifyingEmail
  },
}
</script>
